// @core/api/endpoints/project/create_epic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateEpicRequest,
  EpicResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create epic
 * Creates an epic to group related items together. Epics provide a way to organize work into large features or initiatives.
 */
export async function CreateEpic(
  project_id: string,
  data: CreateEpicRequest,
  options?: RequestOptions
): Promise<EpicResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/epics`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<EpicResponse>(requestPath, data, requestOptions);
}
